import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}
window['CESIUM_BASE_URL'] = 'assets/cesium/';


if(location.search.indexOf('isMac=1') != -1){
  window['isMac'] = ()=>{
    return true;
  }
}

//if new design enabled
if(window['isNewDesign21']){
  document.body.classList.add('es-new-designs')
}

let _script = { name: 'cesium', src: (window['isIOS']() || window['isMac']()) ? `assets/cesium2/Cesium.js?v=${Date.now()}`: 'assets/cesium/Cesium.js' };

let promise = new Promise((resolve, reject) => {
  let script:any = document.createElement('script');
  script.type = 'text/javascript';
  script.src = _script.src;
  console.log('_script', _script)
  if (script.readyState) {  //IE
    script.onreadystatechange = () => {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        resolve({script: 'cesium', loaded: true, status: 'Loaded'});
      }
    };
  } else {  //Others
    script.onload = () => {
      resolve({script: 'cesium', loaded: true, status: 'Loaded'});
    };
  }
  script.onerror = (error: any) => resolve({script: 'cesium', loaded: false, status: 'Loaded'});
  document.getElementsByTagName('head')[0].appendChild(script);
});


promise.then((data)=>{
  Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIwNDcwYmMwZS00MjlkLTRhMDUtODJiMy1hMmFkYmMwOWQ3ODYiLCJpZCI6MzM2NjgsImlhdCI6MTYwMjgzNzQ0OH0.0PFpnseW9b4KQoGDox6shceKt_O0qU_j281Nsd80sik';

  platformBrowserDynamic().bootstrapModule(AppModule)//, {ngZone: 'noop'})
    .catch(err => console.error(err));
});

